import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(3)
  }
}))
